import { useState } from 'react';
import { useProducts } from '../hooks/useProducts';
import { ProductTable } from '../components/ProductTable';
import { ProductFilters } from '../components/ProductFilters';

export function ProductsPage() {
  const [page, setPage] = useState(1);
  const [category, setCategory] = useState('');
  const [sort, setSort] = useState('');
  const [minScore, setMinScore] = useState<number | undefined>();
  const [maxScore, setMaxScore] = useState<number | undefined>();

  const { data, isLoading } = useProducts({
    page,
    category: category || undefined,
    sort: sort || undefined,
    minScore,
    maxScore,
  });

  const handleMinScoreChange = (v: number | undefined) => {
    setMinScore(v);
    setPage(1);
  };

  const handleMaxScoreChange = (v: number | undefined) => {
    setMaxScore(v);
    setPage(1);
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold text-gray-900">Products</h2>
        {data && (
          <span className="text-sm text-gray-500">
            {data.total} product{data.total !== 1 ? 's' : ''}
          </span>
        )}
      </div>

      <div className="card p-4">
        <ProductFilters
          category={category}
          onCategoryChange={setCategory}
          sort={sort}
          onSortChange={setSort}
          minScore={minScore}
          onMinScoreChange={handleMinScoreChange}
          maxScore={maxScore}
          onMaxScoreChange={handleMaxScoreChange}
        />
      </div>

      <div className="card p-4">
        {isLoading ? (
          <div className="text-center py-8 text-gray-500">Loading products...</div>
        ) : (
          <ProductTable products={data?.products ?? []} />
        )}
      </div>

      {data && data.totalPages > 1 && (
        <div className="flex items-center justify-center gap-2">
          <button
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page <= 1}
            className="btn btn-outline text-sm"
          >
            Previous
          </button>
          <span className="text-sm text-gray-600">
            Page {page} of {data.totalPages}
          </span>
          <button
            onClick={() => setPage((p) => Math.min(data.totalPages, p + 1))}
            disabled={page >= data.totalPages}
            className="btn btn-outline text-sm"
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
}
